/**
 * 本地存储
 * Created by slipkinem on 2018/8/13 at 10:49.
 */
type storageType = 'localStorage' | 'sessionStorage';

interface StorageModel<T> {
  value: T;
  $$expires: string | number;
}

// eslint-disable-next-line @typescript-eslint/restrict-template-expressions
const keyPrefix = `AppFinanceH5_20191101_${process.env.VUE_APP_ENV}_`;
/** 一个月常量秒数，用于设置缓存有效期 */
const SECONDS_PER_MONTH = 60 * 60 * 24 * 30;

class Storage {
  constructor(type: storageType) {
    this.type = type;

    // 方便存款等其他项目动态获取缓存前缀
    window[type].setItem('helloFinanceStorageKeyPrefix', keyPrefix);
  }

  private type: storageType;

  /**
   * 设置缓存
   * @param key 缓存key
   * @param value 缓存value
   * @param expires 缓存的有效周期，默认是30天，单位是秒
   * @param lastMilliseconds 可选传入，设置缓存生效的最后时间毫秒点，优先级高于expires
   */
  public set<T = unknown>(
    key: string,
    value: T,
    expires = SECONDS_PER_MONTH,
    lastMilliseconds?: number,
  ) {
    const o: StorageModel<T> = {
      $$expires: lastMilliseconds || (new Date().getTime() + 1000 * expires),
      value,
    };

    window[this.type].setItem(this.prefixKey(key), JSON.stringify(o));
  }

  public get<T = unknown>(key: string): T | null {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const o: StorageModel<T> = JSON.parse(
      window[this.type].getItem(this.prefixKey(key)) || 'null',
    );

    if (!o) {
      return null;
    }

    if (new Date().getTime() > o.$$expires) {
      this.remove(key);

      return null;
    }

    return o.value;
  }

  public remove(key: string) {
    window[this.type].removeItem(this.prefixKey(key));
  }

  // 一次性取出然后删除
  public getAndRemove<T = unknown>(key: string): T | null {
    const v = this.get<T>(key);
    this.remove(key);

    return v;
  }

  private prefixKey(key: string) {
    return keyPrefix + key;
  }
}

export const local = new Storage('localStorage');
export const session = new Storage('sessionStorage');
